module.exports = __webpack_public_path__ + "img/search.4aa0c3e7.svg";